// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"c0bf1254","457":"850f3002","551":"b0ffe9f2","640":"298b6aaf"}[chunkId] + ".chunk.js";
};